import { themeGet } from '@styled-system/theme-get';
import React, { memo } from 'react';
import styled from 'styled-components';
import { variant } from 'styled-system';
import Box from './Box';
const variantStyles = variant({
  key: 'listGroupItems'
});
const StyledListGroupItem = styled(Box).withConfig({
  displayName: "ListGroupItem__StyledListGroupItem",
  componentId: "sc-1qyulzl-0"
})(["", " display:block;width:100%;border:none;text-align:left;line-height:1.5;text-decoration:none;& + &{border-top:", ";}"], variantStyles, props => themeGet('borders.default')(props));
const ListGroupItem = /*#__PURE__*/memo(_ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledListGroupItem, props, children);
});
ListGroupItem.propTypes = {
  ...Box.propTypes,
  ...variantStyles.propTypes
};
ListGroupItem.defaultProps = {
  py: [2, 3],
  px: [3, 4],
  variant: 'default'
};
ListGroupItem.displayName = 'ListGroupItem';
export default ListGroupItem;